const state = () => ({
  product: null
});

export default state;